import React from 'react';
import {observer} from "mobx-react";
import {HelperDate} from "../../helper/HelperDate";
import moment from "moment";
import AdminTable from "../../pages/testTable/AdminTable";

interface Props {
    arUsers: [],
    onLoginRoot: (id:number) => void,
    onFilterUser: (e:any) => void,
}


@observer
export class AdminAuth extends React.Component<Props, {}> {
    render() {
        const {arUsers} = this.props;
        const {
            onLoginRoot,
            onFilterUser
        } = this.props;

        return (<>
            <div className="subtitle">
                <div className="subtitle-text">
                    <span className="subtitle__text">Авторизация под:</span>
                </div>
                <div>
                    {arUsers.length ? <AdminTable productList={arUsers} /> : null}
                </div>
                <div className="subtitle-nav">
                    <div className="search-on-page">

                        <div className="search-form-on-page-wrapper">
                            <input id="search-on-page-input"   onChange={(e) => onFilterUser(e)}   className="search-on-page__text" type="text"
                                   placeholder="Поиск  по всем столбцам"/>
                            <img className="search-on-page__ico" alt="search_ico.svg"
                                 src="/img/ico/personal/Search.svg"/>
                        </div>

                    </div>

                </div>

            </div>

            <div className="user-list-topline no-space-between">
                <div className="td2-1">
                    <div className="td2-1-text">

                    </div>
                    <div className="">
                        <span className="basket-item-top-line__text">Логин</span>
                    </div>

                </div>
                <div className="td2-2">
                    <span className="basket-item-top-line__text">ФИО</span>
                </div>
                <div className="td2-3">
                    <span className="basket-item-top-line__text">Должность</span>
                </div>
                <div className="td2-4">
                    <span className="basket-item-top-line__text">Тип</span>
                </div>
                <div className="td2-5">
                    <span className="basket-item-top-line__text">Клиент</span>
                </div>
                <div className="td2-6">
                    <span className="basket-item-top-line__text">Статус</span>
                </div>
                <div className="td2-7">
                    <span className="basket-item-top-line__text">Дата последнего изменения</span>
                </div>
                <div className="td2-7">
                    <span className="basket-item-top-line__text">Согласие на обработку персональных данных</span>
                </div>
                <div className="td2-7">
                    <span className="basket-item-top-line__text">IP</span>
                </div>
            </div>
            <div className="user-list">
                {arUsers.length ? arUsers.map((user: any) => (
                        <>
                            <div key={'user-' + user.id}
                                 className={user.active ? "user-list-item" : "user-list-item user-list-item-block"}>
                                <div className="td2-1 list-item-border">
                                    <div className="td2-1-text">

                                    </div>
                                    <div className="td2-1-text cursor" onClick={()=>onLoginRoot(user.id)}>
                                        <span className="list-item-text__normal-lightblue">{user.email}</span>
                                    </div>
                                </div>
                                <div className="td2-2 list-item-border">
                                    <div className="client-mobile-title">ФИО</div>
                                    <span className="list-item-text__normal">{user.name ? user.name : user.lastName+' '+user.firstName+' '+user.secondName}</span>
                                </div>
                                <div className="td2-3 list-item-border">
                                    <div className="client-mobile-title">Должность</div>
                                    <span
                                        className="list-item-text__normal">{user.post}</span>
                                </div>
                                <div className="td2-4 list-item-border">
                                    <div className="client-mobile-title">Тип</div>
                                    <span className="list-item-text__normal">{user.type}</span>
                                </div>
                                <div className="td2-5 list-item-border">
                                    <div className="client-mobile-title">Клиент</div>
                                    <span className="list-item-text__normal">{user.client}</span>
                                </div>
                                <div className="td2-6 list-item-border">
                                    <div className="client-mobile-title">Статус</div>
                                    {user.active ? <span
                                            className="list-item-text__normal user-list-item-user-status-active">Активный</span> :
                                        <span
                                            className="list-item-text__normal user-list-item-user-status-block">Заблокирован</span>}
                                </div>
                                <div className="td2-7 list-item-border" style={{borderRight: "2px solid #DAEBF8"}}>
                                    <div className="client-mobile-title">Дата последнего изменения</div>
                                    <div className="td2-7-padding">
                                        <span
                                            className="list-item-text__normal">{HelperDate.getDate(user.updatedAt)}</span>
                                    </div>
                                    <div >
                                        <span
                                            className="list-item-text__normal ">{HelperDate.getTime(user.updatedAt)}</span>
                                    </div>
                                </div>
                                <div className="td2-7 list-item-border">
                                    <div className="client-mobile-title">Согласие на обработку персональных данных</div>
                                    {user.dateConfirmPersonalData !== null ?
                                        <>
                                        <div className="td2-7-padding">
                                        <span
                                        className="list-item-text__normal">{moment(user.dateConfirmPersonalData).format("DD.MM.YYYY HH:mm")}</span>
                                        </div>
                                        </>
                                       : <div>отсутствует</div>}

                                </div>
                                <div className="td2-7 list-item-border">
                                    <div className="client-mobile-title">последний IP</div>
                                    <div className="td2-7-padding">
                                    {user.ip ? user.ip : '-'}
                                    </div>
                                </div>
                            </div>
                        </>
                    ))
                    : (<p className="search-on-page__text"> список пуст</p>)}
            </div>

        </>);
    }
}
